module.exports = __webpack_public_path__ + "static/media/video.60610cfc.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyTurfClub/video.ogv
// module id = 210
// module chunks = 0